/**
 * Jertscript2 Token Types
 * A French satirical programming language that compiles to TypeScript
 */

export enum TokenType {
  // Literals
  NUMBER = 'NUMBER',
  STRING = 'STRING',
  IDENTIFIER = 'IDENTIFIER',

  // Variable declarations
  CROISSANT = 'CROISSANT',     // const
  BAGUETTE = 'BAGUETTE',       // let

  // Boolean and null values
  OUI = 'OUI',                 // true
  NON = 'NON',                 // false
  RIEN = 'RIEN',               // null

  // Control flow
  FRANCHEMENT = 'FRANCHEMENT', // if
  SINON = 'SINON',             // else
  PENDANT = 'PENDANT',         // while
  POUR = 'POUR',               // for

  // Functions
  FONCTION = 'FONCTION',       // function
  RETOURNER = 'RETOURNER',     // return

  // Async/await
  ASYNCHRONE = 'ASYNCHRONE',   // async
  ATTENDRE = 'ATTENDRE',       // await

  // Classes
  CLASSE = 'CLASSE',           // class
  NOUVEAU = 'NOUVEAU',         // new
  CECI = 'CECI',               // this
  CONSTRUCTEUR = 'CONSTRUCTEUR', // constructor

  // Error handling
  MALHEUREUSEMENT = 'MALHEUREUSEMENT', // try
  MERDE = 'MERDE',             // catch
  QUANDMEME = 'QUANDMEME',     // finally
  LANCER = 'LANCER',           // throw

  // Modules
  IMPORTER = 'IMPORTER',       // import
  EXPORTER = 'EXPORTER',       // export
  DE = 'DE',                   // from

  // Logical operators (French keywords)
  ET = 'ET',                   // &&
  OU = 'OU',                   // ||
  PAS = 'PAS',                 // !
  EST = 'EST',                 // ===
  NEST_PAS = 'NEST_PAS',       // !==

  // Loop control
  CASSER = 'CASSER',           // break
  CONTINUER = 'CONTINUER',     // continue

  // Type keywords
  NOMBRE = 'NOMBRE',           // number
  TEXTE = 'TEXTE',             // string
  BOOLEEN = 'BOOLEEN',         // boolean
  QUELCONQUE = 'QUELCONQUE',   // any
  INCONNU = 'INCONNU',         // unknown
  JAMAIS = 'JAMAIS',           // never
  VIDE = 'VIDE',               // void
  TABLEAU = 'TABLEAU',         // Array
  PROMESSE = 'PROMESSE',       // Promise

  // Type system
  INTERFACE = 'INTERFACE',     // interface
  TYPE = 'TYPE',               // type
  ENUMERATION = 'ENUMERATION', // enum
  ETEND = 'ETEND',             // extends
  IMPLEMENTE = 'IMPLEMENTE',   // implements
  COMME = 'COMME',             // as

  // Access modifiers
  PRIVE = 'PRIVE',             // private
  PUBLIQUE = 'PUBLIQUE',       // public
  PROTEGE = 'PROTEGE',         // protected
  LECTURE_SEULE = 'LECTURE_SEULE', // readonly

  // Punctuation
  LPAREN = 'LPAREN',           // (
  RPAREN = 'RPAREN',           // )
  LBRACE = 'LBRACE',           // {
  RBRACE = 'RBRACE',           // }
  LBRACKET = 'LBRACKET',       // [
  RBRACKET = 'RBRACKET',       // ]
  COMMA = 'COMMA',             // ,
  DOT = 'DOT',                 // .
  COLON = 'COLON',             // :
  SEMICOLON = 'SEMICOLON',     // ;
  ARROW = 'ARROW',             // =>
  QUESTION = 'QUESTION',       // ?

  // Arithmetic and comparison operators
  PLUS = 'PLUS',               // +
  MINUS = 'MINUS',             // -
  STAR = 'STAR',               // *
  SLASH = 'SLASH',             // /
  PERCENT = 'PERCENT',         // %
  EQUALS = 'EQUALS',           // =
  DOUBLE_EQUALS = 'DOUBLE_EQUALS', // ==
  NOT_EQUALS = 'NOT_EQUALS',   // !=
  LESS = 'LESS',               // <
  GREATER = 'GREATER',         // >
  LESS_EQUALS = 'LESS_EQUALS', // <=
  GREATER_EQUALS = 'GREATER_EQUALS', // >=
  PLUS_EQUALS = 'PLUS_EQUALS', // +=
  MINUS_EQUALS = 'MINUS_EQUALS', // -=

  // Bitwise/logical symbol operators
  AMPERSAND = 'AMPERSAND',     // &
  PIPE = 'PIPE',               // |
  BANG = 'BANG',               // !

  // Special tokens
  EOF = 'EOF',
  NEWLINE = 'NEWLINE',
}

/**
 * Token interface representing a single lexical unit
 */
export interface Token {
  /** The type of token */
  type: TokenType;
  /** The raw text that was matched */
  lexeme: string;
  /** The literal value (for strings and numbers) */
  literal?: string | number | null;
  /** Line number (1-indexed) */
  line: number;
  /** Column number (1-indexed) */
  column: number;
}
